define(['jquery', 'erv_framework', 'booking_rules'], function ($, ERVFramework, ERVBookingRules) {
	var WarList = function () {
		var self = this;
		self.$ervBody = $('#erv-body');
		self.framework = new ERVFramework();
		self.bookingRules = new ERVBookingRules();

		self.warlistRules = function () {
			var warriskCountries = '';
			self.$ervBody.find('.destination input[name="Countries"]').each(function () {
				warriskCountries += 'Countries=' + $(this).val() + '&';
			});
		}

		self.applyRules = function () {
			self.$ervBody.find('[data-js=continuetrigger], [data-js=nexttrigger], .btn.magnific-popup').each(function () {
				$(this).prop('disabled', true);
				$(this).addClass('is-inactive');
				$(this).on('click', function (e) {
					e.preventDefault();
					e.stopPropagation();
				});
			});
		}
	}

	WarList.prototype.init = function () {
		var self = this;

		if (self.$ervBody.find('#SearchHasWarCountries').length > 0 && self.$ervBody.find('#SearchHasWarCountries').val() === 'True') {
			setTimeout(function () {
				self.framework.popup.openPopup(
					'#warlist-warning',
					{
						elementParse: function (item) {
							$(item.src).removeClass('hide');
							$(item.src).find('[data-js="warlistok"]').on('click', function (e) {
								e.preventDefault();
								$.magnificPopup.close();
							});
						},
						beforeClose: function () {
							self.warlistRules();
						},
						afterClose: function () {
							if (self.$ervBody.find('.bookingselectproductpage').length) {
								self.bookingRules.initHomeInsurance();
							}
						}
					},
					true, false
				);

			}, 2);

			$(document).on('products-loaded', function () {
				self.applyRules();
			});
		}
	};

	return WarList;
});